import React, {FC} from "react";
import Divider from "../divider";
import Spacer from "../spacer";
import VidaSection from "../../../../components/@vida/vida-section";

const ModuleRecoveryGeneral: FC = () => {
  return <div>
    <VidaSection title="" id="module-recovery-general">
      <Divider/>
      <h1>Module Recovery (General)</h1>

      {/* P1 and P2 CAN Module Recovery Procedure */}
      <Spacer/>
      <VidaSection title="P1 and P2 CAN Module Recovery Procedure" id="p1-and-p2-can-module-recovery-procedure">
        <p><strong>TJ 27236: P1 &amp; P2 CAN module recovery</strong></p>
        <p>(does not apply to P3 CAN modules or any MOST modules):</p>
        <p>Connect a battery charger. Use Ignition Position II for the entire procedure.</p>
        <ol>
          <li>Purchase (but do not download) the software product for the affected module.</li>
          <li>Select the Software Advanced tab and Click SEND PROG.</li>
          <li>Choose the correct ECU. When recovering a CEM, the correct ECUs are:
            <ul>
              <li>P1: ECU 50</li>
              <li>P2 -2004: ECU 40</li>
              <li>P2 2005-: ECU 50</li>
            </ul>
          </li>
          <li>READ HW NUMBER and READ SERIAL NUMBER.</li>
        </ol>
        <p>- If the module responds, it is in programming mode. Close the Advanced tab (do not choose SEND RESET). The
          vehicle will remain in programming mode, the DIM will be blank, all lighting will be off. Download the
          software in the normal way.</p>
        <hr/>
        <p>- If the module does not respond, it needs to be manually brought into programming mode. Click SEND
          RESET.</p>
        <p><strong>To manually bring a module into programming mode:</strong></p>
        <ul>
          <li>Confirm the latest version and update of VIDA is being used.</li>
          <li>Confirm the latest DiCE firmware is loaded.</li>
          <li>An external power supply for the DiCE will be needed</li>
        </ul>
        <ol start={5}>
          <li>Check that the battery has sufficient power and disconnect the battery charger.</li>
          <li>Power the DiCE externally. Do not use the vehicle{"'"}s battery.</li>
          <li>Disconnect the negative battery cable.</li>
          <li>Click SEND PROG, wait for the hour-glass to disappear, then connect the battery cable.</li>
          <li>Choose the correct ECU, attempt to READ HW NUMBER and READ SERIAL NUMBER.</li>
        </ol>
        <p>- If the module responds, it is now in PROG mode. Close the Advanced tab (do not choose SEND RESET). The
          vehicle will remain in programming mode, the DIM will be blank, all lighting will be off. Connect the battery
          charger and download the software in the normal way.</p>
        <p>- If the module does not respond, Click SEND RESET and repeat steps 3 and 4. This may take several
          attempts.</p>
        <ol start={10}>
          <li>Once the module responds, connect a battery charger and download software in the normal way.</li>
        </ol>
      </VidaSection>

      {/* Module recovery */}
      <Spacer/>
      <VidaSection title="Module recovery" id="module-recovery">
        <p><strong>Module recovery</strong></p>
        <p>An unresponsive module <em>may</em> be recovered by performing a hard battery reset (disconnect battery for
          at least 30 min.)</p>
        <p>After performing a hard battery reset perform a new readout being certain to
          select <strong>“New”</strong> from the pop-up window (see below from the VIDA help area)</p>
        <p>Then re-try and see if module is now responding.</p>
        <img
          src="https://cdn.volvotechinfo.com/vida-basic-training/Module%20Recovery%20(General)/Module%20recovery%20working%20doc_image.jpg"
          alt="Module recovery working doc_image"/>
      </VidaSection>
    </VidaSection>
    <style jsx>{`
      img {
        width: 100%;
      }
    `}</style>
  </div>
}

export default ModuleRecoveryGeneral;
